module.exports = __webpack_public_path__ + "img/titleBorder.fe1adb82.svg";